import { render } from "./CDHIncarceration.vue?vue&type=template&id=3c1291d2&scoped=true"
import script from "./CDHIncarceration.vue?vue&type=script&lang=js"
export * from "./CDHIncarceration.vue?vue&type=script&lang=js"

import "./CDHIncarceration.vue?vue&type=style&index=0&id=3c1291d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c1291d2"]])

export default __exports__